import { SelectProps } from "@mui/material";
import { ConditionValueSelectorComponentProps } from "../ConditionForm";
import EnumSelect from "../../../common/EnumSelect";
import enumLabel from "../../../../utils/labels/enumLabel";
import { FuelCostEffectiveDay } from "../../../../graphql/generated";

export const DEFAULT_FUEL_COST_EFFECTIVE_DAY = FuelCostEffectiveDay.Monday;

const FUEL_COST_EFFECTIVE_DAYS_IN_WEEK_ORDER = {
  Monday: FuelCostEffectiveDay.Monday,
  Tuesday: FuelCostEffectiveDay.Tuesday,
  Wednesday: FuelCostEffectiveDay.Wednesday,
  Thursday: FuelCostEffectiveDay.Thursday,
  Friday: FuelCostEffectiveDay.Friday,
  Saturday: FuelCostEffectiveDay.Saturday,
  Sunday: FuelCostEffectiveDay.Sunday,
};

const FuelCostEffectiveDaySelect = ({
  value,
  onChange,
  ...otherProps
}: ConditionValueSelectorComponentProps & Pick<SelectProps<string>, "sx">) => (
  <EnumSelect data-testid="fuel-cost-effective-day-select-day"
    label={otherProps.label}
    size="small"
    enumObject={FUEL_COST_EFFECTIVE_DAYS_IN_WEEK_ORDER}
    value={(value as FuelCostEffectiveDay) || DEFAULT_FUEL_COST_EFFECTIVE_DAY}
    onChange={(event, value) => {
      onChange(value);
    }}
    optionLabel={(option) => enumLabel(option) || option}
    {...otherProps}
  />
);

export default FuelCostEffectiveDaySelect;
